import "./info.scss";

const Info = () => {
  return (
    <div className="info">
      <img src={"/icons/info.svg"} width={16} height={16} alt={"Info"} />
      <span>Veriler 15 dk gecikmeli gösterilmektedir.</span>
    </div>
  );
};

export default Info;
